import { createAsyncThunk } from '@reduxjs/toolkit';
import { postApi } from 'redux/apis';

// Get Summary Groups
export const getSummaryAction = createAsyncThunk(
    'summary/getSummary',
    async (params: any = {}, { rejectWithValue }) => {
        try {
            const response = await postApi('/transactions/summary', {
                companyId: localStorage.getItem('companyId'),
                fromDate: params.fromDate,
                toDate: params.toDate,
                accountIds: params.accountIds || [],
                customerIds: params.customerIds || [],
                classIds: params.classIds || [],
                locationIds: params.locationIds || [],
                vendorIds: params.vendorIds || [],
                sortBy: params.sortBy || 'totalAmount',
                sortOrder: params.sortOrder || 'desc',
                page: params.page || 1,
                limit: params.limit || 50,
            });
            return response.data.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);
